import { Component, Input, OnInit } from '@angular/core';
import { PlaylistSchemaDTO, PublisherBookingDTO } from '../../../services/api/api';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { TargetedBookingSetComponent } from '../targeted-booking-set/targeted-booking-set.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sb-comp-playlist-schema',
  templateUrl: './playlist-schema.component.html',
  styleUrls: ['./playlist-schema.component.scss'],
  standalone: false,
})
export class PlaylistSchemaComponent implements OnInit, ModalNavigationComponent {
  @Input() playlist: PlaylistSchemaDTO;
  isInModalContext: boolean;

  bookingMap: Map<number, PublisherBookingDTO>;

  loading: boolean;

  constructor(
    private modalNavigationService: ModalNavigationService,
    private modalService: ModalService,
    private translate: TranslateService
  ) {
    this.loading = true;
    this.playlist = null;
    this.bookingMap = new Map<number, PublisherBookingDTO>();
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.playlist = this.modalNavigationService.getCurrentNavigation().data.playlistScheme;
    }
    if (this.playlist?.staticBookings) {
      for (const booking of this.playlist.staticBookings) {
        this.bookingMap.set(booking.id, booking);
      }
    }
  }

  showBookingSet(setIndex: number | undefined) {
    if (setIndex == null) {
      return;
    }
    if (!this.isInModalContext) {
      this.modalService
        .showNavigationModal({
          entryComponent: { value: TargetedBookingSetComponent, data: { bookingSet: this.playlist.targetedBookings[setIndex] } },
          title: this.translate.instant('lang.globals.bookingSet') + ' ' + setIndex,
          icon: 'targeting',
          modalOptions: { size: 'lg' },
        })
        .then(() => {})
        .catch(() => {});
    } else {
      // already in Modal
      this.modalNavigationService.navigate(TargetedBookingSetComponent, { bookingSet: this.playlist.targetedBookings[setIndex] });
    }
  }
}
